import './MainStructure.scss'
import MainStructure from './MainStructure'

export default MainStructure